// PopupComponent.jsx
import React from "react";
import "./cardComponent.scss";
import Button from "../button/buttonComponent";

const Card = ({
        header = false,
        subheader = false,
        positiveButtonAction = false,
        positiveButtonLabel = false,
        neutralButtonAction = false,
        neutralButtonLabel = false,
        cancelButtonAction = false,
        cancelButtonLabel = false,
        negativeButtonAction = false,
        negativeButtonLabel = false,
        notes = false,
        className,
        children
    }) => {
    return (
        <div className={`customCard ${className || ''}`}>
            {
                header || subheader ?
                <div className="cardHeaderWrapper">
                    <div className="cardHeader">{header}</div>
                    <div className="cardSubheader">{subheader}</div>
                </div> : ""
            }

            {/* Body */}
            <div className="cardBody">
                {children}
            </div>

            {/* Footer */}
            {
                positiveButtonLabel || neutralButtonLabel || cancelButtonLabel || negativeButtonLabel || notes ?
                <div className="cardFooter">
                    <div className="left">
                        {
                            notes ?
                            <div className="note">
                                <i className="fa fa-info-circle"></i> <span>{notes}</span>
                            </div> : ""
                        }
                    </div>
                    
                    <div className="right">
                        { negativeButtonLabel ? <Button className={"small red"} onClick={() => negativeButtonAction?.()}>{negativeButtonLabel}</Button> : "" }
                        { cancelButtonLabel ? <Button className={"small white"} onClick={() => cancelButtonAction?.()}>{cancelButtonLabel}</Button> : "" }
                        { positiveButtonLabel ? <Button className={"small"} onClick={() => positiveButtonAction?.()}>{positiveButtonLabel}</Button> : "" }
                        { neutralButtonLabel ? <Button className={"small white"} onClick={() => neutralButtonAction?.()}>{neutralButtonLabel}</Button> : "" }
                    </div>
                </div> : ""
            }
        </div>
    );
};

export default Card;